import axios from '../../network/axios'
import { ROUNDUP_LIST, ROUNDUP_LIST_REQUEST } from '../types'

const state = {
	isFetching: false,
	items: []
}

const getters = {}

const actions = {
	getRoundups({ commit }) {
		return new Promise((resolve) => {
			commit(ROUNDUP_LIST_REQUEST)
			axios.get('/roundups').then(({ data }) => {
				commit(ROUNDUP_LIST, data)
				resolve()
			})
		})
	},
	reprocessRoundup({ commit, dispatch }, id) {
		return new Promise((resolve, reject) => {
			commit(ROUNDUP_LIST_REQUEST)
			axios
				.put('/payouts/' + id)
				.then(() => {
					dispatch('getRoundups')
					resolve()
				})
				.catch((error) => {
					reject(error.response.data)
				})
		})
	}
}

const mutations = {
	[ROUNDUP_LIST_REQUEST](state) {
		state.isFetching = true
	},
	[ROUNDUP_LIST](state, data) {
		state.isFetching = false
		state.items = data.roundups
	}
}

export default {
	state,
	getters,
	actions,
	mutations
}
